/**
 * Every name and time limit staff View-as uses (M4S-5670,
 * docs/pdlc/cs-view-as-client.md §4 and §9 row 1).
 *
 * A time limit lives here and nowhere else: the server route, the provider and
 * the backstops all read these, so the 12h TTL the server enforces and the 5
 * minutes a tab waits before re-checking can never drift apart.
 */

/** The rollout flag. Per-user overrides only, never enabledInternal (§3). */
export const VIEW_AS_FLAG = 'studio-view-as';

/** Reports as a client. On per environment only once API-1 is deployed there (§7). */
export const VIEW_AS_REPORTS_FLAG = 'studio-view-as-reports';

/** Server env var. `1` refuses every start, resume, check and action (§11). */
export const VIEW_AS_KILL_SWITCH_ENV = 'STUDIO_VIEW_AS_DISABLED';

/** A session ends this long after its start row, whatever happens in between. */
export const VIEW_AS_SESSION_TTL_MS = 12 * 60 * 60 * 1000;

/** A visible tab re-checks its session this often. */
export const VIEW_AS_RECHECK_INTERVAL_MS = 5 * 60 * 1000;

/** A write or a DANI send re-checks first when the last good check is older than this. */
export const VIEW_AS_FRESHNESS_MS = 60 * 1000;

/** A network error keeps the last good state this long, then ends the session. */
export const VIEW_AS_NETWORK_TOLERANCE_MS = 10 * 60 * 1000;

/** `api_write` rows for one ref are written at most once per this window per tab. */
export const VIEW_AS_WRITE_THROTTLE_MS = 60 * 1000;

/** A best-effort stop waits at most this long before the tab reloads. */
export const VIEW_AS_STOP_TIMEOUT_MS = 1_500;

/** The server caches a user's `studio-view-as` read this long. */
export const VIEW_AS_FLAG_CACHE_MS = 60 * 1000;

/** Most rows the client search returns. */
export const VIEW_AS_CLIENT_SEARCH_LIMIT = 50;

/** sessionStorage key for the tab's session: `{ v: 1, staffUserId, sessionId }` only. */
export const VIEW_AS_STORAGE_KEY = 'mfour.viewAs.v1';

/** sessionStorage key for the one-shot "View as ended" reason shown after the reload. */
export const VIEW_AS_END_REASON_KEY = 'mfour.viewAs.endReason.v1';
